import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BroadcastUrgentMessage from './components/BroadcastUrgentMessage';

const { Cell } = ResponsiveGrid;

const Accounting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="緊急事件通知"
        breadcrumbs={[
          {
            name: '公播管理',
          },
          {
            name: '緊急事件通知',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BroadcastUrgentMessage />
    </Cell>
  </ResponsiveGrid>
);

export default Accounting;
